/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useMemo } from 'react';
import { TFunction } from 'i18next';
import { Box, Flex } from '@mantine/core';
import { IconPlus, IconTrash } from '@tabler/icons-react';

import { CreditOptionsResponse, ExpenseType } from 'types';
import { Button, NumberInput, SectionLabel, Select, Text } from 'components';
import { useForm } from '@mantine/form';
import { AppUtils } from 'utils';

interface CreditRequestExpensesProps {
  disabled?: boolean;
  form: any;
  options: CreditOptionsResponse;
  t: TFunction;
}

interface ExpenseObject {
  creditRequestId?: number;
  expenseType?: ExpenseType;
  amount?: number,
}
const tempExpenseObject = {
  creditRequestId: undefined,
  expenseType: undefined,
  amount: undefined,
} as ExpenseObject;

const CreditRequestExpenses = ({ disabled, form, options, t }: CreditRequestExpensesProps) => {

  const propertyName = 'expenses';

  const updateCredit = useCallback(async (array: any) => {
    let tempArray: ExpenseObject[] = [];
    Object.keys(array).forEach(key => {
      let item: ExpenseObject = { ...array[key] };
      const isNotEmpty = item.expenseType || item.amount;
      if (isNotEmpty) {
        item.creditRequestId = form.values.id;
        tempArray.push(item);
      }
    });
    form.setFieldValue(propertyName, tempArray);
  }, []);

  const expenseForm = useForm({
    initialValues: form.values[propertyName] && form.values[propertyName].length > 0 ? form.values[propertyName].map((el: ExpenseObject) => ({ ...el })) : [tempExpenseObject],
    onValuesChange(values, _previous) {
      if (values[values.length - 1] !== tempExpenseObject)
      updateCredit(values);
    },
  });

  const expensesView = useMemo(() => {
    const transformed = expenseForm.getTransformedValues();
    return Object.keys(transformed).map((el: any, index: number) => (
      <Box key={`expense-${index}`}>
        <Flex justify={'space-between'} align={'center'}>
        <SectionLabel label={t('credit.expense.label')} variant={'green'} />
        {index > 0 && !disabled &&
          <Box style={{ textAlign: 'right' }}>
            <Button
              variant={'transparent'}
              size={'compact-sm'}
              color={'var(--mantine-color-error)'}
              mb={6}
              onClick={() => AppUtils.removeObject(expenseForm, index, tempExpenseObject)}
            >
              <IconTrash size={20} />
            </Button>
          </Box>
        }
      </Flex>
        <Select
          label={t('input.expenseType.label')}
          data={options['expenseType'].map(el => (
            { value: el, label: t(`input.expenseType.options.${el}`) }
          ))}
          key={expenseForm.key(`${index}.expenseType`)}
          {...expenseForm.getInputProps(`${index}.expenseType`)}
          clearable={true}
          disabled={disabled}
        />
        <NumberInput
          label={t('input.amount.label')}
          key={expenseForm.key(`${index}.amount`)}
          {...expenseForm.getInputProps(`${index}.amount`)}
          min={0}
          rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
          rightSectionWidth={40}
          disabled={disabled}
        />
      </Box>
    ))
  }, [expenseForm]);

  return (
    <Box>
      {expensesView}
      {!disabled ?
        <Button
          onClick={() => AppUtils.addNewObject(expenseForm, tempExpenseObject)}
          size={'compact-xs'}
          variant={'transparent'}
          mt={'md'}
        >
          <>
            <Box mr={4}><IconPlus size={16} /></Box>
            {t('action.addExpense')}
          </>
        </Button>
      : undefined}
    </Box>
  )
}

export default CreditRequestExpenses;